import { Component, input, output } from '@angular/core';
import { disable } from '@amcharts/amcharts4/.internal/core/utils/Debug';

@Component({
  selector: 'sb-comp-table-select-button',
  templateUrl: './table-select-button.component.html',
  styleUrl: './table-select-button.component.scss',
  standalone: false,
})
export class TableSelectButtonComponent {
  isSelected = input.required<boolean>();
  disabled = input<boolean>(false);
  action = output();
  protected readonly disable = disable;
}
